import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import { lazy, Suspense } from 'react';

export interface RichTextEditorProps {
  value: string;
  onChange: (html: string) => void;
  placeholder?: string;
  label: string;
  disabled?: boolean;
  error?: string;
  minHeight?: number;
}

// tiptap and ProseMirror are ~400 kB, and only the ticket screens write rich text — so the editor
// is split out of the shared UI chunk and fetched when a form actually renders it.
const Impl = lazy(() => import('./rich-text-editor-impl'));

/** Rich-text editor for ticket descriptions and comments. */
export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense
      fallback={
        <Box>
          <Skeleton width={90} height={16} />
          <Skeleton variant="rounded" height={(props.minHeight ?? 160) + 44} />
        </Box>
      }
    >
      <Impl {...props} />
    </Suspense>
  );
}
